<script>
export default {
    watch: {
        showModal(val) {
            document.body.classList[val ? 'add' : 'remove']('modal-open');
        }
    }
}
</script>
